import React, { useState } from 'react';

import { DropdownController, RemoveFavoriteAddressModal } from 'components';
import { FormGroup } from 'components/checkout';

import { getFavoriteAddresses, getFavoriteAddressesOptions } from './helpers';

const FavoritesDropdown = ({ formController, accountAddresses, refetch }) => {
  const [favoriteIdToRemove, setFavoriteIdToRemove] = useState(null);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const { control } = formController;

  const favoriteAddresses = getFavoriteAddresses(accountAddresses);

  const handleFavoriteChange = (favoriteId) => {
    const favorite = favoriteAddresses.find(
      ({ addressId }) => favoriteId === addressId
    );

    formController.reset({
      ...formController.getValues(),
      ...favorite.address,
      // The query returns 'addressId' instead of 'id'
      id: favorite.address.addressId,
    });
  };

  const handleFavoriteRemove = (favoriteId) => {
    setFavoriteIdToRemove(favoriteId);
    setIsRemoveModalOpen(true);
  };

  return (
    <FormGroup>
      <label>Favorite</label>
      <div>
        <DropdownController
          control={control}
          name="id"
          options={getFavoriteAddressesOptions(favoriteAddresses)}
          defaultText="Favorite"
          onChange={handleFavoriteChange}
          onRemoveOption={handleFavoriteRemove}
        />
      </div>
      <RemoveFavoriteAddressModal
        isOpen={isRemoveModalOpen}
        onClose={() => setIsRemoveModalOpen(false)}
        favoriteId={favoriteIdToRemove}
        afterRemoveAddress={refetch}
      />
    </FormGroup>
  );
};

export { FavoritesDropdown };
